//
// const BASE_URL = 'https://adams-development.com:3042'
// eslint-disable-next-line no-restricted-globals
const BASE_URL = new URL('/ce-api', location)
//const BASE_URL = 'http://localhost:57814'

/** Risposta coerente con il resto dell'app quando non si deve chiamare /ce-api (es. offline). */
export const CE_API_OFFLINE_RESPONSE = Object.freeze({
    responseAnyError: true,
    responseData: null,
    skippedBecauseOffline: true
})

const httpReq = async (path, httpMethod, data, withToken) => {
    if (typeof navigator !== 'undefined' && !navigator.onLine) {
        return CE_API_OFFLINE_RESPONSE
    }
    const verifyPath = path[0] !== '/' ? `/${path}` : path
    let headers = {
        'content-type': 'application/json'
        , accept: 'application/json'
    }
    if (withToken) {
        const token = localStorage.getItem('token')
        headers = { ...headers, Authorization: token }
    }
    let fetchObj = {
        method: httpMethod.toUpperCase(),
        headers
    }
    if(data){
        fetchObj = {...fetchObj, body: JSON.stringify(data)}
    }
    const url = `${BASE_URL}${verifyPath}`
    const response = await fetch(`${url}`, fetchObj)
    return response.json()
}
export default httpReq